import { PageHeader } from "../components/PageHeader";
import { Reveal, MaskLinesInView } from "../components/Reveal";
import { ArrowButton } from "../components/Buttons";
import { Marquee } from "../components/Marquee";
import { IMG } from "../data/site";

const About = () => (
  <div data-testid="about-page">
    <PageHeader
      label="About Us"
      lines={["We build brands", "that connect."]}
      intro="Tara Creative Group is a creative marketing and branding agency driven by ideas, strategy and meaningful communication."
    />

    {/* Intro image + text */}
    <section className="bg-cream pb-24 md:pb-32">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <Reveal className="overflow-hidden rounded-sm aspect-[16/9] bg-warm-beige">
          <img src={IMG.aboutHero} alt="Tara Creative Group studio" className="w-full h-full object-cover" />
        </Reveal>

        <div className="grid md:grid-cols-12 gap-8 md:gap-16 mt-16 md:mt-24">
          <Reveal className="md:col-span-4">
            <span className="label text-dark-text/50">Who we are</span>
          </Reveal>
          <div className="md:col-span-8 space-y-8">
            <Reveal>
              <p className="font-serif text-2xl md:text-4xl tracking-tight leading-[1.15] text-dark-text">
                We help brands discover their identity, define their voice and create a presence that people remember.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="font-sans text-base md:text-lg text-dark-text/70 leading-relaxed">
                From brand strategy and visual identity to digital marketing, social media, content creation and creative campaigns, we bring strategy and creativity together to build brands with purpose.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="font-sans text-base md:text-lg text-dark-text/70 leading-relaxed">
                We believe every brand has a story worth telling. Our role is to understand that story, shape it with intention and transform it into creative experiences that connect with the right audience.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>

    <Marquee text="Connect · Create · Grow" dark testid="about-marquee" />

    {/* Our approach */}
    <section className="bg-bottle-green text-cream py-24 md:py-36">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 text-center">
        <Reveal><span className="label text-cream/50">Our approach</span></Reveal>
        <MaskLinesInView
          lines={["Connect.", "Create.", "Grow."]}
          className="block mt-8"
          lineClass="font-serif text-6xl md:text-8xl lg:text-9xl tracking-tight leading-[0.9] text-cream"
        />
        <Reveal delay={0.4} className="mt-14">
          <ArrowButton to="/services" variant="light" testid="about-view-services">Explore Our Services</ArrowButton>
        </Reveal>
      </div>
    </section>
  </div>
);

export default About;
